import axios from 'axios'

export default {
    namespaced: true,
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        fetch({commit, dispatch}, filter) {
            commit('TOGGLE_PRELOADER', true, {root: true})
            return axios.post(
                '/api/root/builds/list', filter
            ).finally(() => {
                commit('TOGGLE_PRELOADER', false, {root: true})
            }).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        add({dispatch}, data) {
            return axios.post(
                '/api/root/builds/add',
                data
            ).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        edit({dispatch}, editedItem) {
            return axios.put(
                '/api/root/builds/edit/' + editedItem.id,
                editedItem
            ).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
        delete({dispatch}, itemId) {
            return axios.delete(
                '/api/root/builds/dell/' + itemId
            ).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        },
    }
}

